import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  installationId: string | number;
  gatewayId: string | number;
}

export function useRemoveGateway() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, gatewayId }: Params) =>
      del({
        url: `/projects/${projectId}/gateways/${gatewayId}`,
      }),
    onSuccess: (_, { projectId, installationId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInstallation(projectId, installationId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getGateways(projectId, 'installationId'),
      });
    },
  });

  const removeGateway = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    removeGateway,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
